import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PROJECT_TICKET_CATEGORY_CONFIG from "../../../../constants/project-ticket-category-config";
import { selectSupplierInfo } from "../../../../store/slices/supplierInfoSlice";
import {
    formatCurrencyToLocale,
    formatValueToLocale,
} from "../../../../utils/method";
import InfoRow from "./InfoRow";
import InfoSection from "./InfoSection";
import { useSectionNumbering } from "../hooks/useSectionNumbering";

const DeductionsSection = () => {
    const { t } = useTranslation();
    const { sectionNumbers } = useSectionNumbering();
    const supplierInfo = useSelector(selectSupplierInfo);
    const { amounts, financialSettings, invoice } = supplierInfo || {
        amounts: {},
        financialSettings: {},
        invoice: {},
    };
    const { guaranteeSecurity } = amounts || {};
    const { isFinalInvoice } = invoice || { isFinalInvoice: false };

    // Configuration for retention row based on invoice type
    const retentionConfig = {
        labelKey: isFinalInvoice ? "supplier-info.warranty-retention" : "supplier-info.security-retention",
        calculatedOrFixField: isFinalInvoice ? "warrantySecurityCalculatedOrFix" : "contractPerformanceSecurityCalculatedOrFix",
        percentField: isFinalInvoice ? "warrantySecurityPercent" : "contractPerformanceSecurityPercent"
    };

    const calculatedOrFixValue = financialSettings?.[retentionConfig.calculatedOrFixField];
    const percentValue = financialSettings?.[retentionConfig.percentField];
    const isCalculated = calculatedOrFixValue === PROJECT_TICKET_CATEGORY_CONFIG.CALCULATION_OPTIONS.CALCULATED;

    return (
        <InfoSection>
            <Row>
                <Col xs={8}>
                    <InfoRow
                        label={`${sectionNumbers.discount}. ${t("supplier-info.discount")}`}
                        value={financialSettings?.discount || 0}
                        suffix="%"
                        name="discountPercent"
                    />
                </Col>
                <Col xs={4}>
                    <InfoRow
                        label=""
                        value={amounts?.discountValue || 0}
                        isNegative={amounts?.discountValue < 0}
                        suffix="€"
                        name="discountValue"
                    />
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md={8}>
                    <Row>
                        <Col md={8}>
                            <>{sectionNumbers.retention}. {t(retentionConfig.labelKey)}</>
                            <div>
                                (
                                {t(
                                    `ticket-category.calculated-or-fix-option.${calculatedOrFixValue}`,
                                )}
                                )
                            </div>
                        </Col>
                        <Col md={4} className="text-end">
                            {isCalculated
                                ? `${formatValueToLocale(percentValue || 0)} %`
                                : `${formatValueToLocale(0)} %`}
                        </Col>
                    </Row>
                </Col>
                <Col
                    md={4}
                    className={`text-end ${guaranteeSecurity?.e11 >= 0 ? "" : "text-danger"}`}
                >
                    {formatCurrencyToLocale(guaranteeSecurity?.e11)}
                </Col>
            </Row>
        </InfoSection>
    );
};

export default DeductionsSection;
